// extracted by mini-css-extract-plugin
export default {"tile_container":"Faa","tile_img_container":"Gaa","not_recommended_label":"Haa","modal_root":"Iaa","content":"Jaa","warning":"Kaa","x_mark":"Laa","tile_img":"Maa","tile_type":"Naa","tile_product_title":"Oaa","tile_product_price":"Paa","tile_descr_line":"Qaa","tile_descr_icon":"Raa","info_icon":"Saa","tile_descr_text":"Taa","tile_btns_container":"Uaa","info_container":"Vaa","info_text":"Waa"};
    if(module.hot) {
      // 1743628931521
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  